export default __webpack_public_path__ + "static/media/passgif.fa5fba12.gif";